import { makeAutoObservable } from "mobx"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { FormHandlerFieldUtils } from "./form-handler"

export default class FormHandlerStore {
   sp

   constructor(sp: FormHandlerFieldUtils) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get value() {
      return this.sp.getValue()
   }

   /** Get the latest value from the formhandler */
   getValue() {
      return this.sp.getValue()
   }

   /** Override any existing errors for this field */
   setError(error: string) {
      this.sp.setError(error)
   }

   /** This resets the errors, but ONLY for this field */
   resetErrors() {
      this.sp.resetErrors()
   }
}

export const { Provider: FormHandlerStoreProvider, useProvidedStore: useFormHandlerStore } = createStoreContext(FormHandlerStore)
